import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { Path } from "../Path";
import { AppWithSideMenu } from "../core/AppWithSideMenu";
import { makeBreadcrumbs } from "../core/Breadcrumbs";
import { InboxListAndDetail } from "./ListAndDetail";
import { s2InboundEmailId } from "../util/type-conversion";

const RedirectFiledMessage = () => {
  const { messageId } = useParams();
  return (
    <Navigate
      to={{
        pathname: Path.inbox().message(s2InboundEmailId(messageId || "")).pathname,
        search: "?STATUS=FILED",
      }}
      replace
    />
  );
};

export const routes = [
  {
    path: Path.inbox().none().pathname,
    element: (
      <AppWithSideMenu>
        <InboxListAndDetail />
      </AppWithSideMenu>
    ),
    handle: {
      crumb: makeBreadcrumbs("Inbox", () => Path.inbox().none(), []),
      prefer: "left",
    },
  },
  {
    path: Path.inbox().message(s2InboundEmailId(":messageId")).pathname,
    element: (
      <AppWithSideMenu>
        <InboxListAndDetail />
      </AppWithSideMenu>
    ),
    handle: {
      crumb: makeBreadcrumbs("Inbox", () => Path.inbox().none(), []),
      prefer: "right",
    },
  },
  {
    path: Path.inbox().filed().none().pathname,
    element: <Navigate to={{ pathname: Path.inbox().none().pathname, search: "?STATUS=FILED" }} replace />,
  },
  {
    path: Path.inbox().filed().message(s2InboundEmailId(":messageId")).pathname,
    element: <RedirectFiledMessage />,
  },
];
